import { Suspense, lazy } from "react";
// components
import { useState, useEffect } from "react";

import LoadingScreen from "../components/loading-screen";
import VehiclesPage from '../pages/fleet/VehiclesPage';
import DriversPage from '../pages/fleet/DriversPage';
import MaintenancePage from '../pages/fleet/MaintenancePage';
// import TripsPage from '../pages/fleet/TripsPage';
import FuelLogsPage from '../pages/fleet/FuelLogsPage';
import FleetDashboard from '../pages/fleet/FleetDashboard';
import DriverApprovalRequestsPages from '../pages/fleet/DriverApprovalRequestsPage';
import CertificateRequestsPages from '../pages/fleet/CertificateRequestsPage';

// ----------------------------------------------------------------------
function useDelayedFallback(fallback, delay = 300) {
  const [showFallback, setShowFallback] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowFallback(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  return showFallback ? fallback : null;
}
const Loadable = (Component) => (props) =>
  (
    <Suspense
      fallback={useDelayedFallback(<LoadingScreen />)}
    >
      <Component {...props} />
    </Suspense>
  );

export const PageOne = Loadable(lazy(() => import("../pages/PageOne")));
export const PageTwo = Loadable(lazy(() => import("../pages/PageTwo")));
export const PageThree = Loadable(lazy(() => import("../pages/PageThree")));
export const PageFour = Loadable(lazy(() => import("../pages/PageFour")));

export const Page404 = Loadable(lazy(() => import("../pages/Page404")));

// -------------------------------------------------------------------------

export const Home = Loadable(lazy(() => import("../pages/Home")));
export const Profile = Loadable(lazy(() => import("../pages/Profile")));
export const CustomerProfile = Loadable(
  lazy(() => import("../pages/CustomerProfile"))
);
export const TimeOffRequests = Loadable(
  lazy(() => import("../pages/TimeOffRequests"))
);
export const SitePage = Loadable(lazy(() => import("../pages/SitePage")));
export const EmployeeProfile = Loadable(
  lazy(() => import("../pages/EmployeeProfile"))
);
export const Schedule = Loadable(lazy(() => import("../pages/SchedulePage")));
export const ShiftTemplate = Loadable(
  lazy(() => import("../pages/ShiftTemplate"))
);
export const ContactsPage = Loadable(
  lazy(() => import("../pages/ContactsPage"))
);
export const JobReqsPage = Loadable(lazy(() => import("../pages/JobReqsPage")));
export const JobApplicationsPage = Loadable(
  lazy(() => import("../pages/JobApplicationsPage"))
);
export const FormSubmissionPage = Loadable(
  lazy(() => import("../pages/FormSubmission"))
);
export const PostOrderEditor = Loadable(
  lazy(() => import("../pages/post-orders/editor"))
);
export const UserPortalTransactions = Loadable(
  lazy(() => import("../pages/UserPortalTransactions"))
);
export const UserPortalTasksPage = Loadable(
  lazy(() => import("../pages/UserPortalTasksPage"))
);
export const UserListPage = Loadable(
  lazy(() => import("../pages/user-management/UserListPage"))
);
export const UserCreatePage = Loadable(
  lazy(() => import("../pages/user-management/UserCreatePage"))
);
export const UserEditPage = Loadable(
  lazy(() => import("../pages/user-management/UserEditPage"))
);
export const LoginPage = Loadable(
  lazy(() => import("../pages/auth/LoginPage"))
);
export const CareersPage = Loadable(
  lazy(() => import("../pages/careers/CareersPage"))
);

export const AuthCallbackPage = Loadable(
  lazy(() => import("../pages/auth/AuthCallbackPage"))
);

export const GmailCallbackPage = Loadable(
  lazy(() => import("../pages/auth/GmailCallbackPage"))
);

export const GmailOAuthCallback = Loadable(
  lazy(() => import("../pages/GmailOAuthCallback"))
);

export const GmailDebugPage = Loadable(
  lazy(() => import("../pages/auth/GmailDebugPage"))
);

export const UserManagementPage = Loadable(
  lazy(() => import("../pages/user-management/UserManagementPage"))
);

export const FleetVehiclesPage = Loadable(
  lazy(() => import("../pages/fleet/VehiclesPage"))
);

export const FleetDriversPage = Loadable(
  lazy(() => import("../pages/fleet/DriversPage"))
);

export const FleetMaintenancePage = Loadable(
  lazy(() => import("../pages/fleet/MaintenancePage"))
);

// export const FleetTripsPage = Loadable(
//   lazy(() => import("../pages/fleet/TripsPage"))
// );

export const FleetFuelLogsPage = Loadable(
  lazy(() => import("../pages/fleet/FuelLogsPage"))
);

export const FleetDashboardPage = Loadable(
  lazy(() => import("../pages/fleet/FleetDashboard"))
);

export const InsurancePoliciesPage = Loadable(lazy(() => import("../pages/fleet/InsuranceList")));
export const DefectReportListPage = Loadable(lazy(() => import("../pages/fleet/DefectReportList")));
export const DriverApprovalRequestsPage = Loadable(lazy(() => import("../pages/fleet/DriverApprovalRequestsPage")));
export const CertificateRequestsPage = Loadable(lazy(() => import("../pages/fleet/CertificateRequestsPage")));
export const ChatPage = Loadable(lazy(() => import("../pages/ChatPage")));

// Site Tasks
export const SiteTaskTemplatesPage = Loadable(lazy(() => import("../pages/site-tasks/TaskTemplatesPage")));
export const SiteTaskAssignmentsPage = Loadable(lazy(() => import("../pages/site-tasks/TaskAssignmentsPage")));
export const SiteTaskDashboardPage = Loadable(lazy(() => import("../pages/site-tasks/TaskDashboardPage")));
export const TaskCompletionTemplateListPage = Loadable(lazy(() => import("../pages/admin/tasks/completion-templates/TaskCompletionTemplateListPage")));

// Site Tasks - Equipment
export const EquipmentListPage = Loadable(lazy(() => import("../pages/site-tasks/EquipmentList")));
export const EquipmentFormPage = Loadable(lazy(() => import("../pages/site-tasks/EquipmentForm")));

// Site Tasks - Detail Views
export const ShiftTaskDetailPage = Loadable(lazy(() => import("../pages/site-tasks/ShiftTaskDetail")));
export const IncidentReportDetailPage = Loadable(lazy(() => import("../pages/site-tasks/IncidentReportDetail")));

// Site Tasks - Analytics
export const TaskPerformanceChartPage = Loadable(lazy(() => import("../pages/dashboard/analytics/TaskPerformanceChart")));
export const TaskCategoryDistributionPage = Loadable(lazy(() => import("../pages/dashboard/analytics/TaskCategoryDistribution")));
export const IncompleteTaskAnalysisPage = Loadable(lazy(() => import("../pages/dashboard/analytics/IncompleteTaskAnalysis")));
export const RoundPerformanceMetricsPage = Loadable(lazy(() => import("../pages/dashboard/analytics/RoundPerformanceMetrics")));
export const GuardPerformanceViewPage = Loadable(lazy(() => import("../pages/dashboard/analytics/GuardPerformanceView")));

// Site Tasks - Equipment Reports
export const EquipmentStatusReportPage = Loadable(lazy(() => import("../pages/dashboard/equipment/EquipmentStatusReport")));
export const EquipmentAnalyticsPage = Loadable(lazy(() => import("../pages/dashboard/equipment/EquipmentAnalytics")));

// Site Tasks - Gamification
export const GamificationSettingsPage = Loadable(lazy(() => import("../pages/dashboard/gamification/GamificationSettings")));
export const GamificationLeaderboardPage = Loadable(lazy(() => import("../pages/dashboard/gamification/GamificationLeaderboard")));
export const AchievementBadgesPage = Loadable(lazy(() => import("../pages/dashboard/gamification/AchievementBadges")));
export const GamificationReportsPage = Loadable(lazy(() => import("../pages/dashboard/gamification/GamificationReports")));

// Notifications
export const NotificationInboxPage = Loadable(lazy(() => import("../pages/notifications/NotificationInboxPage")));
export const NotificationTesterPage = Loadable(lazy(() => import("../pages/notifications/NotificationTesterPage")));
export const GraphQLTesterPage = Loadable(lazy(() => import("../pages/notifications/GraphQLTesterPage")));

// Auth Pages
export const PasswordChangeSuccessPage = Loadable(
  lazy(() => import("../pages/auth/PasswordChangeSuccessPage"))
);

// DAR Pages - COMMENTED OUT TEMPORARILY
// export const DarListPage = Loadable(lazy(() => import("../pages/dar/DarListPage")));
// export const DarEditPage = Loadable(lazy(() => import("../pages/dar/DarEditPage")));
// export const DarInternalPage = Loadable(lazy(() => import("../pages/dar/DarInternalPage")));
// export const DarSendEmailPage = Loadable(lazy(() => import("../pages/dar/DarSendEmailPage")));
// export const EmailTemplateManagementPage = Loadable(lazy(() => import("../pages/admin/EmailTemplateManagement")));